import React from 'react';
import Vision from '../Images/vision.png';
import Mission from '../Images/target.png';

export default function MissionVision() {

    return (
        <section className='grid grid-cols-1 lg:grid-cols-2 px-5 py-[10px] md:py-[30px] md:px-20 lg:space-x-20 space-y-20 md:space-y-0'>
            <div className='space-y-6'>
                <div className='flex justify-center'>
                    <img src={Vision} className="h-36" alt="Vision"/>
                </div>
                <div className='text-[16vw] md:text-[7vw] font-bold lg:text-7xl text-center'>
                    Vision
                </div>
                <div className='text-[5vw] md:text-[4vw] lg:text-2xl text-center'>
                    We aim to be the top leading Entrepreneurship student society all over Egypt that inspire millions of youth to build their own startup as well as spreading the entrepreneurial mindset everywhere.
                </div>
            </div>
            <div className='space-y-6 pt-20 lg:pt-0'>
                <div className='flex justify-center'>
                    <img src={Mission} className="h-36" alt="Mission"/>
                </div>
                <div className='text-[16vw] md:text-[7vw] font-bold lg:text-7xl text-center'>
                    Mission
                </div>
                <div className='text-[5vw] md:text-[4vw] lg:text-2xl text-center'>
                    A student society powered by AAST Entrepreneurship Center which aims to introduce young entrepreneurs by providing exceptional training and network in addition to challenging them through different competitions.
                </div>
            </div>
        </section>
    );
}